import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {CommissionRedirectionLock, UpdateCommissionRedirectionLock} from "../interface/commission-redirection-lock";
import {take} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class CommissionRedirectionLockService {

  constructor(
    private httpClient: HttpClient,
  ) {
  }

  get(): Observable<CommissionRedirectionLock> {
    return this.httpClient
      .get<CommissionRedirectionLock>('/rest/crm/commission-redirection-lock')
      .pipe(take(1));
  }

  update(
    data: UpdateCommissionRedirectionLock
  ): Observable<void> {
    return this.httpClient
      .post<void>('/rest/crm/commission-redirection-lock', data)
      .pipe(take(1));
  }
}
